import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <>
      <Helmet>
        <title>404 Page Not Found | Avendra UI</title>
      </Helmet>
      <div className="flex flex-col items-center justify-center min-h-[80vh] px-4 text-center">
        <p className="text-[120px] font-bold leading-none text-[#0E80B4] select-none">404</p>
        <h1 className="text-2xl font-semibold text-gray-800 mt-2">Page Not Found</h1>
        <p className="text-sm text-gray-500 mt-3 max-w-md">
          Sorry, we couldn&apos;t find the page you&apos;re looking for. The page may have been
          moved, deleted, or the URL might be incorrect.
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 px-6 py-2.5 bg-[#0E80B4] text-white text-sm font-medium rounded-md hover:bg-[#0A6A96] transition-colors"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            className="w-4 h-4"
          >
            <path
              fillRule="evenodd"
              d="M17 10a.75.75 0 0 1-.75.75H5.612l4.158 3.96a.75.75 0 1 1-1.04 1.08l-5.5-5.25a.75.75 0 0 1 0-1.08l5.5-5.25a.75.75 0 1 1 1.04 1.08L5.612 9.25H16.25A.75.75 0 0 1 17 10Z"
              clipRule="evenodd"
            />
          </svg>
          Back to Home
        </Link>
      </div>
    </>
  );
}
